/* istanbul ignore file */
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { patchAccount } from 'state/callers/account';
import { myAccountSelector } from 'state/selectors/account';
import { getRootTeamSelector } from 'state/selectors/teams';
import { selectedTeamSelector } from 'state/selectors/ui-state';
import useToast from 'components/hooks/useToast';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';

const useTreeTeamsSetting = () => {
  const dispatch = useDispatch();
  const toast = useToast();

  const account = useSelector(myAccountSelector) || {};
  const selectedTeam = useSelector(selectedTeamSelector) || {};
  const accountSettings = _.get(account, 'settings');
  const rootTeamId = useSelector(getRootTeamSelector);
  const selectedTeamId = _.get(selectedTeam, 'id');

  const addRootTeamToFavorites = async ({ id, name }) => {
    try {
      await patchAccount(account.id, {
        settings: Object.assign(accountSettings, { root_team: id })
      })(dispatch);

      toast({
        message: (
          <>
            <b>{name}</b> was successfully set as the root team
          </>
        ),
        variant: 'success'
      });
      TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
        page: TRACKING.PAGES.DASHBOARD,
        page_tab: TRACKING.PAGE_TABS.TOPBAR,
        click_type: TRACKING.CLICK.SET_GROUP_AS_ROOT
      });
    } catch {
      toast({
        message: (
          <>
            Could not set <b>{name}</b> as root
          </>
        ),
        variant: 'error'
      });
    }
  };

  const removeRootTeamFromFavorites = async ({ name = null }) => {
    const accountSettings = _.omit(account.settings, ['root_team']);

    try {
      await patchAccount(account.id, {
        settings: accountSettings
      })(dispatch);

      if (name) {
        toast({
          message: (
            <>
              <b>{name}</b> was successfully canceled as the root team
            </>
          ),
          variant: 'success'
        });
      }
      TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
        page: TRACKING.PAGES.DASHBOARD,
        page_tab: TRACKING.PAGE_TABS.TOPBAR,
        click_type: TRACKING.CLICK.REMOVE_GROUP_AS_ROOT
      });
    } catch {
      if (name) {
        toast({
          message: (
            <>
              Could not cancel <b>{name}</b> as the root team
            </>
          ),
          variant: 'error'
        });
      }
    }
  };
  return {
    rootTeamId,
    selectedTeamId,
    addRootTeamToFavorites,
    removeRootTeamFromFavorites
  };
};

export default useTreeTeamsSetting;
